import { render } from "./nav_bottom.vue?vue&type=template&id=0b6be179&scoped=true"
import script from "./nav_bottom.vue?vue&type=script&lang=js"
export * from "./nav_bottom.vue?vue&type=script&lang=js"

import "./nav_bottom.vue?vue&type=style&index=0&id=0b6be179&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6be179"]])

export default __exports__